<template>
    <header
        class="site header"
        role="banner">
        <div class="ux container">
            <div class="d-flex align-items-stretch">
                <div
                    class="d-flex flex-column justify-content-stretch m-0 p-0">
                    <div
                        class="d-block m-0 p-0">
                        <content-item
                            bundle-name="Header"
                            item-key="LOGO_LEFT"
                            class="m-0 p-0">
                        </content-item>
                    </div>
                </div>
                <div
                    class="d-flex flex-column justify-content-stretch mx-3"
                    style="margin-top: 1rem !important;margin-bottom: 1rem !important;">
                    <div
                        class="border-left border-secondary h-100"
                        style="border-left-color: #CCD3E0 !important; border-left-width: 1.5px !important;">
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-center p-0">
                    <div
                        class="d-block m-0 p-0">
                        <content-item
                            bundle-name="Header"
                            item-key="LOGO_RIGHT"
                            class="m-0 p-0">
                        </content-item>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import PgbaBaseComponent from '../../common/components/PgbaBaseComponent.vue';
export default {
    name: 'HeaderComponent',
    extends: PgbaBaseComponent
};
</script>